import * as React from "react";

const useEffectOnce = (fn: Function, arr: any[]) => {
  const called = React.useRef(false);

  React.useEffect(() => {
    if (called.current) return;
    fn();
    return () => {
      called.current = true;
    };
  }, arr);

  return called.current;
};

export default useEffectOnce;
